module.exports = __webpack_public_path__ + "static/bgdesktop-0ad9f31c4025c33ab59f8e13aae2431e.png";